module.exports = __webpack_public_path__ + "img/ico_dog.23ef4372.png";